export default __webpack_public_path__ + "static/media/blue-download.36de38d6.svg";